var module = angular.module('octopusApp.projects');

module.factory('missingTenantVariablesLoader', function($q, octopusRepository) {

    return {
        missingVariables: function(tenantId){
            var missingByTemplate = [];
            var loadingPromise = $q.defer();
            var vm  = {
                isLoading: true,
                loadingAsync: loadingPromise.promise,
                isMissingVariable: false,
                isMissingProjectVariable: false,
                isMissingLibraryVariable: false,
                isMissing: isMissing
            };

            function isMissing(templateId, environmentId) {
                if (!missingByTemplate[templateId]) {
                    return false;
                }

                return _.any(missingByTemplate[templateId], function(missing){
                    return missing.EnvironmentId === environmentId;
                });
            }

            octopusRepository.Tenants.missingVariables({
                tenantId: tenantId
            }, true).then(function (result) {
                vm.isLoading = false;
                vm.isMissingVariable = result.length > 0;
                if (vm.isMissingVariable) {
                    missingByTemplate = _.groupBy(result[0].MissingVariables, function(item) { return item.VariableTemplateId; });
                    var missingProjectVariables = result[0].MissingVariables.filter(function(a) { return !!a.ProjectId; });
                    vm.isMissingProjectVariable = missingProjectVariables.length > 0;
                    vm.isMissingLibraryVariable = ( result[0].MissingVariables.length - missingProjectVariables.length) > 0;
                }
                loadingPromise.resolve(vm);
            }, function(err) {
                loadingPromise.reject(err);
            });
            return vm;
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/tenants/variables/missingTenantVariablesLoader.js
// module id = 2061045127772198
// module chunks = 1